import PropTypes from "prop-types";
import React from "react";
import { Button, Card } from "reactstrap";
import moment from 'moment'
import { RenderAmount } from "../../utils";
import "./oder-info.scss";

const OderInfo = (props) => {
  const {
    id,
    price,
    name,
    addressFullText,
    handleDetail,
    createdAt,
    cancelReason,
    status,
  } = props;

  return (
    <Card outline className="oder-info border mb-1 point-click">
      <div onClick={handleDetail}>
        <div className="oder-info_infoCustomer"><b className="text-info">{[name, id].filter(Boolean).join(' - ')}</b></div>
        <div className="oder-info_address text-warning">
          {moment(createdAt).format('HH:mm DD-MM-YYYY')}
        </div>
        <div className="oder-info_address">
          {addressFullText || "-"}
        </div>
        {price && <div className="oder-info_totalPrice text-primary">
          <RenderAmount price={price} />
        </div>}
        {status === 'CANCELED' ?
          <div className="oder-info_totalPrice text-danger">
            Lý do huỷ: {cancelReason || "Không có lý do"}
          </div>
          : null}
      </div>
    </Card>
  );
};

export default OderInfo;

OderInfo.propTypes = {
  name: PropTypes.string,
  phone: PropTypes.string,
  addressFullText: PropTypes.string,
  price: PropTypes.number,
  handleDetail: PropTypes.func,
  createdAt: PropTypes.string,
};
